/* eslint-disable */
// This file was automatically generated and should not be edited.

import * as Types from '../../../../../__generated__/globalTypes';

import { ReviewFragment } from '../../../__generated__/Reviews';
import { gql } from '@apollo/client';
import { ReviewFragmentDoc } from '../../../__generated__/Reviews';
import * as Apollo from '@apollo/client';
const defaultOptions = {};
export type ProductPhotoReviewsQueryVariables = Types.Exact<{
  id: Types.Scalars['String'];
  after?: Types.Maybe<Types.Scalars['String']>;
  first?: Types.Maybe<Types.Scalars['Int']>;
}>;

export type ProductPhotoReviewsQuery = {
  product?: Types.Maybe<
    Pick<Types.Product, 'id'> & {
      reviews?: Types.Maybe<{
        pageInfo: Pick<Types.PageInfo, 'hasNextPage' | 'endCursor'>;
        edges?: Types.Maybe<
          Array<
            Types.Maybe<
              Pick<Types.ReviewEdge, 'cursor'> & {
                review?: Types.Maybe<Pick<Types.Review, 'id'> & ReviewFragment>;
              }
            >
          >
        >;
      }>;
    }
  >;
};

export const ProductPhotoReviewsDocument = gql`
  query ProductPhotoReviews($id: String!, $after: String, $first: Int) {
    product(id: $id) {
      id
      reviews(after: $after, first: $first, hasPhoto: true) {
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          cursor
          review: node {
            id
            ...Review
          }
        }
      }
    }
  }
  ${ReviewFragmentDoc}
`;

/**
 * __useProductPhotoReviewsQuery__
 *
 * To run a query within a React component, call `useProductPhotoReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductPhotoReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductPhotoReviewsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useProductPhotoReviewsQuery(
  baseOptions: Apollo.QueryHookOptions<ProductPhotoReviewsQuery, ProductPhotoReviewsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ProductPhotoReviewsQuery, ProductPhotoReviewsQueryVariables>(
    ProductPhotoReviewsDocument,
    options,
  );
}
export function useProductPhotoReviewsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProductPhotoReviewsQuery,
    ProductPhotoReviewsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ProductPhotoReviewsQuery, ProductPhotoReviewsQueryVariables>(
    ProductPhotoReviewsDocument,
    options,
  );
}
export type ProductPhotoReviewsQueryHookResult = ReturnType<typeof useProductPhotoReviewsQuery>;
export type ProductPhotoReviewsLazyQueryHookResult = ReturnType<
  typeof useProductPhotoReviewsLazyQuery
>;
export type ProductPhotoReviewsQueryResult = Apollo.QueryResult<
  ProductPhotoReviewsQuery,
  ProductPhotoReviewsQueryVariables
>;
